import { Alert, Stack, Text, Title } from "@mantine/core";
import { IconInfoCircle, IconPlus } from "@tabler/icons-react";
import { useNavigate } from "react-router-dom";
import { PageHeader } from "../../../components/PageHeader";
import { PresetScriptsList } from "./PresetScriptsList";

export const PresetScriptsHome = () => {
  const navigate = useNavigate();

  return (
    <div className="wp-fade-in">
      <PageHeader
        title="Preset Scripts"
        subtitle="Reusable Lua presets that build tournament rule sets"
        showBreadcrumbs={false}
        actions={[
          {
            label: "Create Preset",
            icon: <IconPlus size={16} />,
            onClick: () => navigate("/tournaments/preset-scripts/new"),
            variant: "filled",
          },
        ]}
      />
      <Stack gap="lg">
        <Text>
          Preset scripts are user-defined Lua programs that can be applied to a
          tournament step to generate its full rule set: scoring, advancement,
          structure and cross-step rules. Each preset can declare typed
          parameters that are filled in when the preset is applied, allowing a
          single script to power many different formats.
        </Text>

        <Alert icon={<IconInfoCircle />} color="indigo" variant="light">
          Presets are written in Lua. Define parameters with explicit types so
          consumers see the right input controls when applying a preset to a
          tournament step.
        </Alert>

        <Title order={3}>Manage your presets</Title>
        <PresetScriptsList />
      </Stack>
    </div>
  );
};
